import { RootState } from "store/index";

const currentSiteId = (state: RootState): number | null =>
  state.currentSite.currentSiteId;

export default {
  currentSiteId,
};
